import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Studio render error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="min-h-screen bg-[#f4f4f6] flex items-center justify-center p-6">
        <section className="w-full max-w-lg border border-[#dc553c]/40 bg-white p-6 shadow-sm">
          <div className="flex items-center gap-2 text-[#8c2d1f]">
            <AlertCircle className="w-5 h-5" />
            <h1 className="text-base font-bold">Studio could not render this view</h1>
          </div>
          <p className="mt-3 text-sm text-gray-600">
            The generation job is unchanged. Reload Studio to return to the last saved state.
          </p>
          <pre className="mt-4 max-h-36 overflow-auto bg-[#f9f4ec] p-3 text-xs text-[#8c2d1f] whitespace-pre-wrap">
            {this.state.error.message}
          </pre>
          <button
            onClick={() => window.location.reload()}
            className="mt-5 inline-flex items-center gap-2 bg-[#258cc0] px-4 py-2 text-sm font-bold text-white hover:bg-[#1a6a9e]"
          >
            <RefreshCw className="w-4 h-4" />Reload Studio
          </button>
        </section>
      </main>
    );
  }
}